import React, { useState, useEffect } from "react";
import homelogo from "../../assets/Image/RALINGOBlack.png";
import SliderImg1 from "../../assets/Image/Slider11.jpg";
import { Link } from "react-router-dom";
import { FaLocationDot } from "react-icons/fa6";
import { axiosInstance } from "../../config";
import { MdOutlineKeyboardDoubleArrowRight } from "react-icons/md";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import BackgroundImageLightLeft from "../../assets/Image/BackgroundImageLightLeft.png";
import { FaXTwitter } from "react-icons/fa6";
import { IoIosCall } from "react-icons/io";
import { MdEmail } from "react-icons/md";
import "./MainFooter.css";
import {
  faFacebook,
  faLinkedin,
  faPinterest,
  faYoutube,
  faInstagram,
  faTwitter,
} from "@fortawesome/free-brands-svg-icons";

const MainFooter = () => {
  const [rootCollection, setRootCollection] = useState([]);
  useEffect(() => {
    const getAllRootCollections = async () => {
      try {
        const { data } = await axiosInstance.get(
          "/api/collection/getRootCollection"
        );

        if (data?.success) {
          setRootCollection(data?.data);
        }
      } catch (error) {
        console.log(error);
      }
    };
    getAllRootCollections();
  }, []);

  return (
    <>
      <div
        className="row"
        style={{
          backgroundImage: `url(${BackgroundImageLightLeft})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      >
        <div className="col-lg-4" style={{ paddingTop: "30px" }}>
          <center>
            <img alt="" src={homelogo} style={{ height: "12vh" }}></img>
          </center>
          <p
            className="Footer1sectionstyle"
            style={{ textAlign: "justify", color: "#6B6B83" }}
          >
            At Railingo Private Limited, we revolutionize architectural spaces
            with bespoke metallic creations. Our expert design team and
            cutting-edge machinery empower us to collaborate with architects,
            interior designers, and builders, offering unparalleled, innovative
            solutions.
            <br></br>
            Discover the future of architecture with our one-stop, custom
            solutions.
          </p>
        </div>
        <div className="col-lg-2 Footer2sectionstyle">
          <b style={{ fontSize: "18px" }}>Information</b>
          <br></br>
          <br></br>
          <a
            href="/AboutUs"
            style={{
              color: "#6B6B83",
              fontSize: "15px",
              textDecoration: "none",
            }}
          >
            <MdOutlineKeyboardDoubleArrowRight
              style={{ color: "#475B52", fontWeight: "800", fontSize: "20px" }}
            />
            &nbsp; About Railingo
          </a>
          <br></br>
          <a
            href="/CompletedProject"
            style={{
              color: "#6B6B83",
              fontSize: "15px",
              textDecoration: "none",
            }}
          >
            <MdOutlineKeyboardDoubleArrowRight
              style={{ color: "#475B52", fontWeight: "800", fontSize: "20px" }}
            />
            &nbsp; Completed Project
          </a>
          {/* <br></br>
          <a
            href="/ExperienceCenters"
            style={{
              color: "#6B6B83",
              fontSize: "15px",
              textDecoration: "none",
            }}
          >
            Experience Centers
          </a>
          <br></br>
          <a
            href="#"
            style={{
              color: "#6B6B83",
              fontSize: "15px",
              textDecoration: "none",
            }}
          >
            Find a Studio
          </a> */}
          <br></br>
          <a
            href="/PartnerWithUs"
            style={{
              color: "#6B6B83",
              fontSize: "15px",
              textDecoration: "none",
            }}
          >
            <MdOutlineKeyboardDoubleArrowRight
              style={{ color: "#475B52", fontWeight: "800", fontSize: "20px" }}
            />
            &nbsp; Partner With Us
          </a>
          <br></br>
          <a
            href="/Exibhitions"
            style={{
              color: "#6B6B83",
              fontSize: "15px",
              textDecoration: "none",
            }}
          >
            <MdOutlineKeyboardDoubleArrowRight
              style={{ color: "#475B52", fontWeight: "800", fontSize: "20px" }}
            />
            &nbsp; Exhibitions
          </a>

          <br></br>
          <a
            href="/PrivacyPolicy"
            style={{
              color: "#6B6B83",
              fontSize: "15px",
              textDecoration: "none",
            }}
          >
            <MdOutlineKeyboardDoubleArrowRight
              style={{ color: "#475B52", fontWeight: "800", fontSize: "20px" }}
            />
            &nbsp; Privacy Policy
          </a>
          <br></br>
          <a
            href="/TermsandCondition"
            style={{
              color: "#6B6B83",
              fontSize: "15px",
              textDecoration: "none",
            }}
          >
            <MdOutlineKeyboardDoubleArrowRight
              style={{ color: "#475B52", fontWeight: "800", fontSize: "20px" }}
            />
            &nbsp; Terms & Conditions
          </a>
          <br></br>
          <a
            href="/CancelationPolicy"
            style={{
              color: "#6B6B83",
              fontSize: "15px",
              textDecoration: "none",
            }}
          >
            <MdOutlineKeyboardDoubleArrowRight
              style={{ color: "#475B52", fontWeight: "800", fontSize: "20px" }}
            />
            &nbsp; Cancellation Policy
          </a>
        </div>
        {/* <div className="col-lg-2" style={{ padding: "30px 0px 0px 0px" }}>
          <b style={{ fontSize: "18px", backgroundColor:"#475B52", color:"#fff" }}>Customer Service</b>
          <br></br>
          <br></br>
          <span style={{ color: "#6B6B83", fontSize: "15px" }}>
            Support Center
          </span>
          <br></br>
          <span style={{ color: "#6B6B83", fontSize: "15px" }}>
            Returns & Refunds
          </span>
          <br></br>
          <span style={{ color: "#6B6B83", fontSize: "15px" }}>
            Shipping Guide
          </span>
          <br></br>
          <span style={{ color: "#6B6B83", fontSize: "15px" }}>
            Design Services
          </span>
          <br></br>
          <span style={{ color: "#6B6B83", fontSize: "15px" }}>Financing</span>
          <br></br>
          <span style={{ color: "#6B6B83", fontSize: "15px" }}>
            About COVID-19
          </span>
          <br></br>
          <span style={{ color: "#6B6B83", fontSize: "15px" }}>
            Track Order
          </span>
        </div> */}

        <div className="col-lg-3 Footer3sectionstyle">
          <b style={{ fontSize: "18px" }}>Contact Us</b>
          {/* <br></br>
          <br></br>
          <a
            style={{
              color: "#6B6B83",
              fontSize: "15px",
              border: "1px solid #6B6B83",
              padding: "7px 12px 7px 12px",
              borderRadius: "10px",
              textDecoration: "none",
              fontWeight: "600",
            }}
          >
            Customer Service
          </a> */}
          <br></br> <br></br>
          <p>
            <span
              style={{ fontWeight: "600", fontSize: "16px", color: "#000" }}
            >
              <IoIosCall style={{ fontSize: "16px," }} /> &nbsp;&nbsp;
            </span>
            <Link to="tel:+918755999395" target="_blank">
              <span style={{ fontSize: "14px", color: "#6B6B83" }}>
                +91 8755999395
              </span>
            </Link>
          </p>
          <p>
            <span
              style={{ fontWeight: "600", fontSize: "16px", color: "#000" }}
            >
              <MdEmail style={{ fontSize: "16px," }} />
              &nbsp;&nbsp;
            </span>
            {/* <Link to="mailto:info@railingo.in" target="_blank">
              <span style={{ fontSize: "14px", color: "#6B6B83" }}>
                info@railingo.in
              </span>
            </Link>
            ,&nbsp; */}
            <Link to="mailto:sales@railingo.com" target="_blank">
              <span style={{ fontSize: "14px", color: "#6B6B83" }}>
                sales@railingo.com
              </span>
            </Link>
          </p>
          <p>
            <span
              style={{ fontWeight: "600", fontSize: "16px", color: "#000" }}
            >
              <FaLocationDot style={{ fontSize: "16px," }} />
              &nbsp;&nbsp;
            </span>
            <Link
              to="https://www.google.com/maps/place/Railingo+Private+Limited+-+Aluminium+gate%2F+Steel+railing+manufacturers+in+Gurugram/@28.3687967,76.9095783,17z/data=!3m1!4b1!4m6!3m5!1s0x390d3fc3db268bb9:0x9145ad1945e6231!8m2!3d28.3687967!4d76.9095783!16s%2Fg%2F11wxtmkdnb?entry=ttu&g_ep=EgoyMDI1MDUyOC4wIKXMDSoASAFQAw%3D%3D"
              target="_blank"
            >
              <span style={{ fontSize: "14px", color: "#6B6B83" }}>
                Plot No.-149, Sector 4, Imt Manesar, Gurugram, Haryana 122051
                India
              </span>
            </Link>
            <br></br>
            <br></br>
            <a target="_blanck" href="https://www.instagram.com/railingo_">
              <FontAwesomeIcon
                icon={faInstagram}
                style={{ color: "#833AB4", fontSize: "20px" }}
              />
            </a>{" "}
            &nbsp;&nbsp;&nbsp;&nbsp;
            <a
              target="_blanck"
              href="https://www.facebook.com/railingoprivatelimited/"
            >
              <FontAwesomeIcon
                icon={faFacebook}
                style={{ color: "#1877F2", fontSize: "20px" }}
              />
            </a>{" "}
            &nbsp;&nbsp;&nbsp;&nbsp;
            <a target="_blanck" href="https://x.com/railingo__?s=11">
              <FaXTwitter
                icon={faTwitter}
                style={{ color: "#000", fontSize: "20px", marginTop: "-10px" }}
              />
            </a>
            &nbsp;&nbsp;&nbsp;&nbsp;
            <a
              target="_blanck"
              href="https://www.linkedin.com/company/railingo-pvt-ltd/"
            >
              <FontAwesomeIcon
                icon={faLinkedin}
                style={{ color: "#0077B5", fontSize: "20px" }}
              />
            </a>{" "}
            &nbsp;&nbsp;&nbsp;&nbsp;
            <a
              target="_blanck"
              href="https://in.pinterest.com/Railing_official/"
            >
              <FontAwesomeIcon
                icon={faPinterest}
                style={{ color: "#E60023", fontSize: "20px" }}
              />{" "}
            </a>
            &nbsp;&nbsp;&nbsp;&nbsp;
            <a
              target="_blanck"
              href="https://www.youtube.com/@Railingo_official"
            >
              <FontAwesomeIcon
                icon={faYoutube}
                style={{ color: "#FF0000", fontSize: "20px" }}
              />
            </a>{" "}
          </p>
        </div>

        <div className="col-lg-3 Footer4sectionstyle">
          <iframe
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3510.6709340549537!2d76.90957829999999!3d28.3687967!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x390d3fc3db268bb9%3A0x9145ad1945e6231!2sRailingo%20Private%20Limited%20-%20Aluminium%20gate%2F%20Steel%20railing%20manufacturers%20in%20Gurugram!5e0!3m2!1sen!2sin!4v1748679625671!5m2!1sen!2sin"
            className="MapStylingFooter"
            // style="border:0;"
            loading="lazy"
            title="_railingo"
            referrerPolicy="no-referrer-when-downgrade"
          ></iframe>
        </div>
      </div>
    </>
  );
};

export default MainFooter;
